import { getPatternStyles, patternFns, __spreadValues } from '../helpers.mjs';
import { css } from '../css/index.mjs';

const levelLeftConfig = {
transform(props) {
  return __spreadValues({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gridArea: "left"
  }, props);
}}

export const getLevelLeftStyle = (styles = {}) => {
  const _styles = getPatternStyles(levelLeftConfig, styles)
  return levelLeftConfig.transform(_styles, patternFns)
}

export const levelLeft = (styles) => css(getLevelLeftStyle(styles))
levelLeft.raw = getLevelLeftStyle